import { PtLuxonDate } from '../projects/date.models';

export class DailyObservationEditor {
    id: number;
    localId: number;
    date: PtLuxonDate;
    isCompleted: boolean;
    lastTwentyFourHours: string;
    nextTwentyFourHours: string;
    extraWork: string;
    seajacksActivitiesEngineering: string;
    seajacksActivitiesDeck: string;
    customSectionInstances: CustomDprSectionInstance[] = [];
}

export class CustomDprSectionInstance {
  dprSectionId: number;
  title: string;
  text: string;
}




// WEBPACK FOOTER //
// ./src/models/daily-observations/daily-observations.ts